/**
 * Simple hash of constants for use in the application.
 * Add as needed or when have time to refactor -- eg: Java enums for note types
 * TODO: put css constants on here, maybe others held elsewhere
 */

module.exports = {

    NON_RESPONSIVE_REASON_CODE: 'Non-Responsive'

};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/constants.js
 ** module id = 768
 ** module chunks = 0
 **/